<template>
  <div>
    <files type="protocolCompanyContractFiles"></files>
  </div>
</template>

<script>
import files from './files.vue'
export default {
  components: { files },

  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped></style>